// extracted by mini-css-extract-plugin
export var active = "_av-7";
export var container = "_av-0";
export var evenWidth = "_av-4";
export var large = "_av-5";
export var outlet = "_av-8";
export var slide = "_av-2";
export var small = "_av-6";
export var tab = "_av-3";
export var tabs = "_av-1";